let header = document.querySelector(".header")
let headerBtn = document.querySelector(".header__fixedBtnsBtnMenu")
let headerLinks = document.querySelectorAll(".header a")
let body = document.body

headerBtn.addEventListener("click", () => {
    header.classList.toggle("is-on");
    body.classList.toggle("header-is-on");
    noscroll(header.classList.contains("is-on"))
})
headerLinks.forEach((link) => {
    link.addEventListener("click", () => {
        header.classList.remove("is-on");
        body.classList.remove("header-is-on");
        noscroll(header.classList.contains("is-on"))
    })
})


function noscroll(bool) {
    if (bool) {
        body.style.overflow = "hidden"
    } else {
        body.style.overflow = ""
    }
}